module.exports = __webpack_public_path__ + "img/addimage.c760f137.png";